<template>
  <div>
    <div class="top">
      <h1 v-bg-typography="'h1'" :style="{ marginTop: '10px' }">Scenes</h1>
      <!-- <bg-button
        v-if="
          !this.isLoading && this.test && this.data && $route.params.id != 363
        "
        @click="handleProcessVideo"
        text="Regenerate results"
      ></bg-button> -->
    </div>
    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
    <div class="message" v-if="showMessage && !isLoading && !isProcessing">
      <bg-icon name="alertCircle"></bg-icon>
      <div class="content">
        “When you have enough participants, click the button on the right. This
        will generate one heatmap video and average emotion scores for all
        participants for further analysis.”
      </div>
      <bg-button @click="handleProcessVideo" text="Create results"></bg-button>
    </div>
    <div
      class="message"
      style="justify-content: flex-start"
      v-if="isProcessing"
    >
      <bg-icon name="alertCircle"></bg-icon>
      <div class="content">
        The video is being processed. This can take up to 3-10 minutes.
      </div>
    </div>
    <div v-if="!this.isLoading && this.test && this.data && dataReady">
      <sections
        :data="data"
        :testId="test.id"
        test-platform="video"
        :test-internal-state="test.internal_state"
      ></sections>
    </div>
  </div>
</template>

<script>
import BgTypography from "@/directives/bg-typography";
import BgIcon from "@/components/bg-icon";
import BgButton from "@/components/bg-button";
import Sections from "@/routes/dashboard/research/research-participants/research-participant/sections";
import API from "@/api";
import BgLoader from "@/components/bg-loader";

export default {
  components: {
    BgIcon,
    BgButton,
    Sections,
    BgLoader,
  },
  directives: {
    BgTypography,
  },
  data() {
    return {
      data: null,
      isLoading: true,
      isProcessing: false,
      localTestState: null,
      test: null,
    };
  },
  computed: {
    showMessage: function () {
      if (this.data) {
        return false;
      } else {
        return true;
      }
    },
    dataReady: function () {
      // Ensure data is loaded and has required properties
      return (
        this.data &&
        this.data.emotions &&
        this.data.mice &&
        this.data.eyes &&
        Array.isArray(this.data.sections)
      );
    },
  },
  async created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      try {
        this.test = await API.test.getTest(this.$route.params.id);

        if (this.test.participants.find((el) => el.type === "video_heatmap")) {
          this.data = await API.test.getVideoParticipant(this.$route.params.id);
          console.log("Video participant data loaded:", this.data);

          // Ensure sections have labels
          if (this.data && this.data.sections) {
            this.data.sections = this.data.sections.filter((s) => s.label);
          }
        } else if (this.test.internal_state === "video_processing") {
          await this.checkInternalStateAndLoadData(this.test.internal_state);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleProcessVideo() {
      API.test.processVideoTest(this.$route.params.id);
      this.localTestState = "video_processing";
      this.checkInternalStateAndLoadData(this.localTestState);
    },
    async checkInternalStateAndLoadData(state) {
      if (state) {
        this.isProcessing = true;
        setTimeout(async () => {
          try {
            const result = await API.test.getTest(this.$route.params.id);
            this.checkInternalStateAndLoadData(result.internal_state);
          } catch (error) {
            console.error("Error checking internal state:", error);
            this.checkInternalStateAndLoadData(state);
          }
        }, 10000);
      } else {
        this.isProcessing = false;
        const vm = this;
        setTimeout(async () => {
          try {
            vm.data = await API.test.getVideoParticipant(this.$route.params.id);
            console.log(
              "Video participant data loaded after processing:",
              vm.data
            );

            // Ensure sections have labels
            if (vm.data && vm.data.sections) {
              vm.data.sections = vm.data.sections.filter((s) => s.label);
            }
          } catch (error) {
            console.error("Error loading video participant:", error);
          }
        }, 5000);
      }
    },
  },
};
</script>

<style scoped>
@import "./styles.scss";
</style>
